module.exports = __webpack_public_path__ + "img/vertical_6_2_8004.d02575cb.png";